import {
  AnalyticsEventAction,
  AnalyticsEventType,
} from '@th/shared/src/types/AnalyticsEvent';
import Link from 'next/link';
import React from 'react';
import logEvent from '../helpers/mutations/logEvent';
import Logo from './Logo';
import scrollToSection from '../helpers/scrollToSection';
import { Container } from './Container';
import MobileNavHamburger from './MobileNavHamburger';
import { useRouter } from 'next/router';
import { LANDING_PAGE_NAVBAR_LINKS } from '../constants/landingPageNavbarLinks';
import NoSsr from 'react-no-ssr';

type Props = {};

export default function NavBar({}: Props) {
  const { route } = useRouter();
  const isOnHomePage = route === '/';

  return (
    <header>
      <nav>
        <Container className="relative z-20 flex justify-between py-8">
          <div className={'z-20'}>
            <Link href={'/'} legacyBehavior={false} className="items-center">
              <Logo size={24} showText />
            </Link>
          </div>
          <ul
            className={
              'hidden lg:flex flex-1 justify-end items-center gap-12 uppercase text-xs'
            }
          >
            {isOnHomePage ? (
              <div
                onClick={() => {
                  scrollToSection('features');
                }}
              >
                <li className={'cursor-pointer'}>Features</li>
              </div>
            ) : null}
            {LANDING_PAGE_NAVBAR_LINKS.map(link => {
              return (
                <Link href={link.href} key={link.href}>
                  <li className={'cursor-pointer'}>{link.title}</li>
                </Link>
              );
            })}
            <button
              type={'button'}
              className={'btn uppercase hover:bg-darkGray'}
              onClick={() => {
                logEvent({
                  action:
                    AnalyticsEventAction.clicked_download_button_in_navbar,
                  type: AnalyticsEventType.download_button_click,
                });
                scrollToSection('download');
              }}
            >
              Download
            </button>
          </ul>
          <div className="justify-end">
            <NoSsr>
              <MobileNavHamburger />
            </NoSsr>
          </div>
        </Container>
      </nav>
    </header>
  );
}
